import React from "react";
import T from "prop-types";
import { useCurrentUser } from "APP_ROOT/hooks";
import { hasAnyOfSubroles } from "MODULES/users/helpers";
import {
  CREATE_COMMERCIAL_INVOICE,
  WAREHOUSE_EXPERT,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { ImprovedDropDownItem } from "../../../../../shared/components/DropDown";
import { Modal } from "./Modal";

export default function CreateCommercialInvoice({ shipment }) {
  if (shipment.get("reference_record_type") !== "SalesOrder") {
    return null;
  }

  const user = useCurrentUser();

  if (
    !hasAnyOfSubroles(user, [
      CREATE_COMMERCIAL_INVOICE,
      WAREHOUSE_LOGISTICS_DIRECTOR,
      WAREHOUSE_EXPERT
    ])
  ) {
    return null;
  }

  return (
    <ImprovedDropDownItem
      faIcon="dollar"
      label="Create Commercial Invoice"
      renderActive={<Modal shippingRecord={shipment.toJS()} />}
    />
  );
}

CreateCommercialInvoice.propTypes = {
  shipment: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Actions/CreateCommercialInvoice/CreateCommercialInvoice.jsx